import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ProfileHeaderProps {
  isCreateMode: boolean;
}

const ProfileHeader: React.FC<ProfileHeaderProps> = ({ isCreateMode }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Box display="flex" alignItems="center" mb={3}>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(-1)}
        sx={{ mr: 2 }}
      />
      <Typography variant="h4">
        {isCreateMode ? t('screening_profile.add_profile') : t('screening_profile.edit_profile')}
      </Typography>
    </Box>
  );
};

export default ProfileHeader; 